import sdl from '@jds/react-generated-sdl/JDSTable';
import type { JDSTableProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, TableProps } from '../logic';

const Component = (props: TableProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    density = 'undefined',
    background = false,
    columnDivider = false,
    fullWidth = false,
    ariaLabel = 'table',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { density, background, columnDivider, fullWidth, ariaLabel, ...rest },
    'JDSTable',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Table = withLogic(Component) as React.FC<TableProps> & {
  slotName?: string;
};

Table.displayName = 'Table';
Table.slotName = 'jds_table';

export { Table, type JDSTableProps };
